<template>
    <div>
        <PageLoader :storage="appLoading" />
        <ServerError v-if="ServerError" />

        <v-snackbar v-model="showSnackBar" color="#FF6907" right :timeout="timeout">
            <v-layout wrap justify-center>
                <v-flex text-left class="align-self-center">
                    <span style="color: #fff">{{ msg }}</span>
                </v-flex>
                <v-flex text-right>
                    <v-btn small :ripple="false" text @click="showSnackBar = false">
                        <v-icon style="color: #fff">mdi-close</v-icon>
                    </v-btn>
                </v-flex>
            </v-layout>
        </v-snackbar>

        <v-layout wrap justify-center>
            <v-flex xs12>
                <v-layout wrap justify-start>
                    <!-- Filters & Action Bar -->
                    <v-flex xs12>
                        <v-layout wrap justify-space-between align-center>
                            <!-- District Filter -->
                            <v-flex xs12 sm3 md3 lg3>
                                <span class="subheading">District</span>
                                <v-select outlined hide-details placeholder="Select" dense :items="districts"
                                    v-model="districtFilter"></v-select>
                            </v-flex>

                            <!-- Keyword Search -->
                            <v-flex xs12 sm4 md4 lg4 :class="$vuetify.breakpoint.smAndUp ? 'px-3' : 'pt-2'">
                                <span class="subheading">Search Keyword</span>
                                <v-text-field outlined hide-details placeholder="Name/Phone/Rescuer Code" dense
                                    v-model="keyword" clearable></v-text-field>
                            </v-flex>

                            <!-- Add Button -->
                            <v-flex xs12 sm3 md3 lg3 class="text-right"
                                :class="$vuetify.breakpoint.smAndUp ? '' : 'pt-2'"
                                v-if="userRole === 'admin' || userRole === 'division' || userRole === 'circle'">
                                <v-btn color="#FF6907" depressed dark @click="openAddDialog()" class="mt-5">
                                    <span style="color: #fff; font-size: 13px; font-family: poppinssemibold;">
                                        Add External Ban <v-icon right>mdi-plus</v-icon>
                                    </span>
                                </v-btn>
                            </v-flex>
                        </v-layout>
                    </v-flex>

                    <!-- Table -->
                    <v-flex xs12 class="pt-5" v-if="userlist && userlist.length > 0">
                        <v-card>
                            <v-simple-table>
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th class="text-center tableheading">Rescuer Code</th>
                                            <th class="text-center tableheading">Name</th>
                                            <th class="text-center tableheading">Phone</th>
                                            <th class="text-center tableheading">Email</th>
                                            <th class="text-center tableheading">District</th>
                                            <th class="text-center tableheading">Reason</th>
                                            <th class="text-center tableheading" v-if="userRole === 'admin' || userRole === 'division' || userRole === 'circle'">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody class="tablesubheading">
                                        <tr v-for="(item, index) in userlist" :key="index" class="text-center">
                                            <td>{{ item.rescuerCode || '-' }}</td>
                                            <td>{{ item.name || '-' }}</td>
                                            <td>{{ item.phone || '-' }}</td>
                                            <td>{{ item.email || '-' }}</td>
                                            <td>{{ item.district || '-' }}</td>
                                            <td>{{ item.banreason || '-' }}</td>
                                            <td v-if="userRole === 'admin' || userRole === 'division' || userRole === 'circle'">
                                                <div class="d-flex align-center justify-center">
                                                    <!-- Edit Button -->
                                                    <v-icon color="green" small
                                                        @click="openEditDialog(item)">mdi-pencil</v-icon>
                                                    <!-- Unban Button -->
                                                    <v-icon color="red" small class="ml-5"
                                                        @click="openUnbanDialog(item._id)">mdi-swap-horizontal</v-icon>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-flex>

            <!-- Pagination -->
            <v-flex xs12 pb-4 v-if="userlist && userlist.length > 0">
                <v-layout wrap justify-center>
                    <v-flex xs10>
                        <v-pagination v-model="currentPage" :length="Pagelength" :total-visible="7" circle
                            color="#FF6907" small></v-pagination>
                    </v-flex>
                </v-layout>
            </v-flex>

            <!-- Empty State -->
            <v-flex xs12 pt-16 v-else>
                <v-layout wrap justify-center align-center>
                    <v-flex xs12 class="text-center">
                        <span class="nodata">No Data Found !</span>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>

        <!-- Add/Edit Form Dialog -->
        <v-dialog v-model="formDialog" max-width="800" persistent>
            <v-card>
                <v-card-title class="heading">{{ isEditMode ? 'Edit Banned Rescuer' : 'Ban External Rescuer'
                    }}</v-card-title>

                <v-card-text class="pt-4">
                    <v-form ref="banForm" v-model="formValid">
                        <v-layout wrap>
                            <v-flex xs12 sm6 px-2>
                                <v-text-field label="Name *" v-model="form.name" :rules="requiredRules" outlined dense
                                    color="#FF6907" />
                            </v-flex>
                            <v-flex xs12 sm6 px-2>
                                <v-text-field label="Phone *" v-model="form.phone" :rules="requiredRules" outlined dense
                                    color="#FF6907" />
                            </v-flex>
                            <v-flex xs12 sm6 px-2>
                                <v-text-field label="Email" v-model="form.email" outlined dense color="#FF6907" />
                            </v-flex>
                            <v-flex xs12 sm6 px-2>
                                <v-text-field label="Rescuer Code" v-model="form.rescuerCode" outlined dense
                                    color="#FF6907" />
                            </v-flex>
                            <v-flex xs12 sm6 px-2>
                                <v-select label="District *" :items="districts.filter(d => d !== 'All')"
                                    v-model="form.district" :rules="requiredRules" outlined dense color="#FF6907" />
                            </v-flex>
                            <v-flex xs12 sm6 px-2>
                                <v-text-field label="Ban Reason *" v-model="form.banreason" :rules="requiredRules"
                                    outlined dense color="#FF6907" />
                            </v-flex>
                            <v-flex xs12 sm6 px-2>
                                <v-text-field label="ID Type" v-model="form.idType" outlined dense color="#FF6907" />
                            </v-flex>
                            <v-flex xs12 sm6 px-2>
                                <v-text-field label="ID Number" v-model="form.idNumber" outlined dense
                                    color="#FF6907" />
                            </v-flex>
                            <v-flex xs12 sm6 px-2>
                                <v-text-field label="Aadhaar Number" v-model="form.adharnumber" outlined dense
                                    color="#FF6907" />
                            </v-flex>
                            <v-flex xs12 sm6 px-2>
                                <v-text-field label="Education" v-model="form.education" outlined dense
                                    color="#FF6907" />
                            </v-flex>
                            <v-flex xs12 sm6 px-2>
                                <v-text-field label="Employment" v-model="form.employment" outlined dense
                                    color="#FF6907" />
                            </v-flex>
                            <v-flex xs12 sm6 px-2>
                                <v-text-field label="Blood Group" v-model="form.bloodGroup" outlined dense
                                    color="#FF6907" />
                            </v-flex>
                            <v-flex xs12 sm6 px-2>
                                <v-text-field label="Rescue Started At (YYYY)" v-model="form.rescueStartedAt" outlined
                                    dense color="#FF6907" />
                            </v-flex>
                            <v-flex xs12 px-2>
                                <v-textarea label="Permanent Address" v-model="form.permanentAddress" outlined dense
                                    color="#FF6907" rows="2" />
                            </v-flex>
                            <v-flex xs12 px-2>
                                <v-textarea label="Present Address" v-model="form.presentAddress" outlined dense
                                    color="#FF6907" rows="2" />
                            </v-flex>
                        </v-layout>
                    </v-form>
                </v-card-text>

                <v-card-actions class="pb-4 pr-4">
                    <v-spacer></v-spacer>
                    <v-btn tile outlined color="#FF1313" @click="formDialog = false" class="itemValue">
                        Cancel
                    </v-btn>
                    <v-btn tile color="#FF6907" depressed @click="saveExternalBan()" class="itemValue">
                        <span style="color: #fff">Confirm</span>
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Unban Confirmation Dialog -->
        <v-dialog v-model="unbanDialog" max-width="500">
            <v-card>
                <v-card-title class="heading">Confirmation</v-card-title>
                <v-card-text>
                    Are you sure you want to revoke the ban of this external rescuer?
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn tile outlined color="#FF1313" @click="unbanDialog = false" class="itemValue">
                        Cancel
                    </v-btn>
                    <v-btn tile color="#FF6907" depressed @click="unbanExternalUser()" class="itemValue">
                        <span style="color: #fff">Confirm</span>
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import axios from "axios";

export default {
    data() {
        const pageKey = this.$route.name || 'defaultPage_external';
        return {
            appLoading: false,
            ServerError: false,
            showSnackBar: false,
            timeout: 5000,
            msg: null,
            count: 20,
            keyword: "",
            districtFilter: "All",
            pageKey,
            currentPage: 1,
            Pagelength: 0,
            userlist: [],
            unbanDialog: false,
            formDialog: false,
            isEditMode: false,
            unbanId: null,
            formValid: false,
            requiredRules: [v => !!v || 'This field is required'],
            form: {
                id: "",
                name: "",
                phone: "",
                email: "",
                rescuerCode: "",
                permanentAddress: "",
                presentAddress: "",
                district: "",
                idType: "",
                idNumber: "",
                banreason: "",
                adharnumber: "",
                education: "",
                employment: "",
                bloodGroup: "",
                rescueStartedAt: ""
            }
        };
    },
    beforeMount() {
        this.$store.dispatch("fetchDistricts");
        this.getData();
    },
    watch: {
        currentPage() {
            this.getData();
        },
        districtFilter() {
            this.getData();
            this.currentPage = 1;
        },
        keyword() {
            this.getData();
            this.currentPage = 1;
        }
    },
    methods: {
        // Fetch the list of banned external rescuers
        getData() {
            this.appLoading = true;
            axios({
                method: "GET",
                url: "/rescuer/external/bannedlist",
                headers: {
                    "x-auth-token": localStorage.getItem("token"),
                },
                params: {
                    count: this.count,
                    page: this.currentPage,
                    keyword: this.keyword,
                    district: this.districtFilter === "All" ? "" : this.districtFilter
                },
            })
                .then((response) => {
                    this.appLoading = false;
                    if (response.data.status === true) {
                        this.userlist = response.data.data;
                        this.Pagelength = response.data.pages;
                    } else {
                        this.userlist = [];
                        this.msg = response.data.msg;
                        this.showSnackBar = true;
                    }
                })
                .catch((err) => {
                    this.appLoading = false;
                    this.ServerError = true;
                    console.error(err);
                });
        },

        // Dialog control triggers
        openAddDialog() {
            this.isEditMode = false;
            this.form = {
                id: "",
                name: "",
                phone: "",
                email: "",
                rescuerCode: "",
                permanentAddress: "",
                presentAddress: "",
                district: "",
                idType: "",
                idNumber: "",
                banreason: "",
                adharnumber: "",
                education: "",
                employment: "",
                bloodGroup: "",
                rescueStartedAt: ""
            };
            if (this.$refs.banForm) {
                this.$refs.banForm.resetValidation();
            }
            this.formDialog = true;
        },
        openEditDialog(item) {
            this.isEditMode = true;
            this.form = {
                id: item._id,
                name: item.name || "",
                phone: item.phone || "",
                email: item.email || "",
                rescuerCode: item.rescuerCode || "",
                permanentAddress: item.permanentAddress || "",
                presentAddress: item.presentAddress || "",
                district: item.district || "",
                idType: item.idType || "",
                idNumber: item.idNumber || "",
                banreason: item.banreason || "",
                adharnumber: item.adharnumber || "",
                education: item.education || "",
                employment: item.employment || "",
                bloodGroup: item.bloodGroup || "",
                rescueStartedAt: item.rescueStartedAt || ""
            };
            if (this.$refs.banForm) {
                this.$refs.banForm.resetValidation();
            }
            this.formDialog = true;
        },
        openUnbanDialog(id) {
            this.unbanId = id;
            this.unbanDialog = true;
        },

        // Save (Create or Edit) Handler
        saveExternalBan() {
            if (!this.$refs.banForm.validate()) {
                this.msg = "Please fill in all required fields.";
                this.showSnackBar = true;
                return;
            }

            this.appLoading = true;
            const isEdit = this.isEditMode;
            const url = isEdit ? "/rescuer/external/edit" : "/rescuer/external/ban";

            axios({
                method: "POST",
                url: url,
                headers: {
                    "x-auth-token": localStorage.getItem("token"),
                },
                data: this.form,
            })
                .then((response) => {
                    this.appLoading = false;
                    if (response.data.status === true) {
                        this.msg = isEdit ? "Edited successfully." : "Banned successfully.";
                        this.showSnackBar = true;
                        this.formDialog = false;
                        this.getData();
                    } else {
                        this.msg = response.data.msg;
                        this.showSnackBar = true;
                    }
                })
                .catch((err) => {
                    this.appLoading = false;
                    this.ServerError = true;
                    console.error(err);
                });
        },

        // Unban Handler
        unbanExternalUser() {
            this.appLoading = true;
            axios({
                method: "POST",
                url: "/rescuer/external/unban",
                headers: {
                    "x-auth-token": localStorage.getItem("token"),
                },
                data: {
                    id: this.unbanId,
                },
            })
                .then((response) => {
                    this.appLoading = false;
                    if (response.data.status === true) {
                        this.msg = "Revoked Successfully.";
                        this.showSnackBar = true;
                        this.unbanDialog = false;
                        this.getData();
                    } else {
                        this.msg = response.data.msg;
                        this.showSnackBar = true;
                        this.unbanDialog = false;
                    }
                })
                .catch((err) => {
                    this.appLoading = false;
                    this.ServerError = true;
                    console.error(err);
                });
        }
    },
    computed: {
        userRole() {
            return this.$store.state.userRole || localStorage.getItem("userRole");
        },
        districts() {
            return ["All", ...this.$store.state.districts];
        }
    }
};
</script>

<style>
.heading {
    font-family: poppinsregular;
    font-size: 20px;
    font-weight: 900;
}

.subheading {
    font-family: poppinsregular;
    font-size: 15px;
    font-weight: 500;
}

.tableheading {
    font-family: poppinsregular;
    font-size: 15px !important;
    color: black !important;
    text-transform: uppercase !important;
}

.tablesubheading {
    font-family: poppinsregular;
    font-size: 10px;
}
</style>
